import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Hidden from '@material-ui/core/Hidden'
import Menu from '@material-ui/icons/Menu'
// @material-ui/icons
import CurrentNav from '../../components/CurrentNav/CurrentNav'
import Content from './ContentNavBar'
import styles from '../../assets/jss/material-dashboard-react/layout/headerStyle'
import { CabeceraContext } from '../CurrentNav/CabeceraContext'

const useStyles = makeStyles(styles)

export default function Header(props) {
  const classes = useStyles()

  const { color } = props
  const appBarClasses = classNames({
    [' ' + classes[color]]: color,
  })
  return (
    <>
      <AppBar position="fixed" className={classes.appBar + appBarClasses} style={{borderRadius: 0, background: 'linear-gradient(135deg, #004BCE 11%, #2BCE75 100%)'}}>
        <Toolbar className={classes.container}>
          <div className={classes.flex}>
            <CurrentNav />
          </div>
          <Hidden smDown implementation="css">
            {<Content />}
          </Hidden>
          <Hidden mdUp implementation="css">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={props.handleDrawerToggle}
            >
              <Menu />
            </IconButton>
          </Hidden>
        </Toolbar>
      </AppBar>
      <CabeceraContext />
    </>
  )
}

Header.propTypes = {
  color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object),
}
